import React from 'react';
import logonouse from '../../assets/images/nousedev-icon-32px.png'

const versionApp = process.env.REACT_APP_VERSION;

const CreditItem = () => {

    return (
        <div className={`card`} id={'card-credit'}>
            <a href={"https:///nousedev.fr"} target={'_blank'} rel={'noopener noreferrer'} className={'img-logo-ref'}>
                <div className="card-body">
                    <div>
                        réalisation Nouse Dev - Damien RAMBOURG &copy;2020
                    </div>
                    <img className={'img-logo-ref'} src={logonouse} alt={"Nouse Dev"}/>
                    {versionApp &&
                    <div>
                        <small> {`version ${versionApp}`}</small>
                    </div>}
                </div>
            </a>
        </div>
    );
};

export default CreditItem;